import MobileTabBar from './mobile-tab-bar'

export default MobileTabBar
